var widget_default = {
  "card": "A111S",
  "link": "n2yOp",
  "container": "_6JKSc",
  "image": "mET5u",
  "right": "_2JPIu",
  "cardLayout": "SaSr-",
  "content": "MTw5j",
  "title": "tR2GM",
  "subtitle": "K35Fs",
  "button": "JTh7N",
  "button_disabled": "_8amRc",
  "buttonText": "eCoIg",
  "slimLayout": "qTQS1",
  "contentText": "eNagF"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
